import { useMutation, useQueryClient } from 'react-query';

import { createCompanyPest } from 'api/clients/createCompanyPest';

const useCreatePestCompany = () => {
  const queryClient = useQueryClient();
  const {
    isSuccess,
    mutate: createNewCompanyPest,
    isLoading,
  } = useMutation(createCompanyPest, {
    onSuccess: () => {
      queryClient.invalidateQueries('clients');
    },
  });

  return {
    isSuccess,
    createNewCompanyPest,
    isLoading,
  };
};

export default useCreatePestCompany;
